// extracted by mini-css-extract-plugin
export default {"comment_icon_button":"CommentIconButton_comment_icon_button__wWKI8","comment_icon_button__badge":"CommentIconButton_comment_icon_button__badge__DwX2K"};